// extracted by mini-css-extract-plugin
export default {"note":"EmailVerificationCode_note__W0rWh","ggg":"EmailVerificationCode_ggg__o-Fgc"};